import React from 'react';
import { Alert, Button } from '@mui/material';

// A map-provider failure must not take the operational forms and tables down with it.
class MapErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    const { children, onFallback } = this.props;
    const { failed } = this.state;
    return failed ? (
      <Alert severity="warning" action={<Button onClick={onFallback}>Use standard map</Button>}>
        Google Maps is unavailable. You can continue working or switch to the standard map.
      </Alert>
    ) : children;
  }
}

export default MapErrorBoundary;
